export const AUTHHYDRATE_APP = "AUTHHYDRATE_APP";
export const AUTHHYDRATE_SUCCESS = "AUTHHYDRATE_SUCCESS";
